/* eslint-disable import/prefer-default-export */
import moment from 'moment';
export function getEnhancedMessages(messages) {
    return messages === null || messages === void 0 ? void 0 : messages.map((message, index, arr) => {
        const currentSender = message.sender.username;
        const nextMessage = arr[index + 1];
        const nextSender = nextMessage === null || nextMessage === void 0 ? void 0 : nextMessage.sender.username;
        const currentDate = moment(message.createdDate);
        const nextDate = nextMessage ? moment(nextMessage.createdDate) : null;
        const isNextDayDifferent = nextDate && !currentDate.isSame(nextDate, 'day');
        const isNextSenderDifferent = currentSender !== nextSender;
        // Last message of a consecutive run from the same sender shows the name/avatar.
        const showName = isNextSenderDifferent;
        const showDate = isNextDayDifferent || isNextSenderDifferent;
        return Object.assign(Object.assign({}, message), { showName,
            showDate });
    });
}
